import { Box } from '@theme-ui/components';
import styled from '@emotion/styled';

import { screenMedium, screenSmall } from '@app/styles/theme/breakpoints';
import fontSizes from '@app/styles/theme/fontSizes';

export const ContentWrapper = styled(Box)`
  max-width: ${({ theme }) => theme.layout.containerMaxWidth};
  margin: 0 auto;
  font-size: ${fontSizes[2]};
`;

export const BottomContent = styled(Box)`
  margin: 4rem auto 0;
  line-height: 1.5;
  text-align: center;
  font-weight: 500;
  font-size: ${fontSizes[2]};
  padding: 1rem 0;

  @media (min-width: ${screenSmall}) {
    margin: 6rem auto 3rem;
    max-width: ${screenSmall};
    padding: 0 2rem;
  }

  @media (min-width: ${screenMedium}) {
    max-width: ${screenMedium};
    margin: 6rem auto;
  }
`;
